import RenderListening from "components/Practice/listening/RenderListening";
import * as React from "react";
import useQuery from "hooks/useQuery";
import { useHistory } from "react-router-dom";
import { useAsync } from "react-async-hook";
import Spinner from "components/Spinner";
import { Typography } from "@material-ui/core";
import MainWrapper from "layout/MainWrapper";
import { fetchListening } from "utilities/awsCRUD";
import useHomework from "hooks/useHomework";

interface ListeningDetailViewProps {}

const ListeningDetailView: React.FC<ListeningDetailViewProps> = () => {
  const { onSubmit, submittedAnswers, title, time } = useHomework();
  const history = useHistory();
  let query = useQuery();
  const id = query.get("id");
  const typeName = query.get("typeName");
  React.useEffect(() => {
    if (!id || !typeName) {
      history.push("/practice");
    }
  }, [id, typeName, history]);
  const listeningPractice = useAsync(fetchListening, [id, typeName]);
  return (
    <>
      {listeningPractice.loading && <Spinner />}
      {listeningPractice.error && (
        <MainWrapper>
          <Typography variant="h5" color="error">
            Error: {listeningPractice.error.message}
          </Typography>
        </MainWrapper>
      )}
      {listeningPractice.result && (
        <RenderListening
          practice={listeningPractice.result}
          title={title ? `Listening ${title}` : "Listening Practice"}
          onSubmit={onSubmit}
          time={time}
          submittedAnswers={submittedAnswers}
        />
      )}
    </>
  );
};

export default ListeningDetailView;
